// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__23kFI","content":"Page_content__126na","scrollingDisabled":"Page_scrollingDisabled__3LnaR"};